/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPayorTypeSummary
 */
export interface HchbPayorTypeSummary {
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the HchbPayorTypeSummary interface.
 */
export function instanceOfHchbPayorTypeSummary(value: object): value is HchbPayorTypeSummary {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function HchbPayorTypeSummaryFromJSON(json: any): HchbPayorTypeSummary {
    return HchbPayorTypeSummaryFromJSONTyped(json, false);
}

export function HchbPayorTypeSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPayorTypeSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function HchbPayorTypeSummaryToJSON(json: any): HchbPayorTypeSummary {
    return HchbPayorTypeSummaryToJSONTyped(json, false);
}

export function HchbPayorTypeSummaryToJSONTyped(value?: HchbPayorTypeSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

